import { createSlice } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import { OMSPROFILE } from '../../../API';
import { logFrontendActivity } from '../../General/activityLogger';

export const profileslice = createSlice({
    name: 'profile',
    initialState: {
        profile: {},
        meta: [],
        loading: false,
        hasErrors: false,
        message: "",
        notification: { show: false, messageContent: "", messageType: "success" }
    },
    reducers: {
        getProfile: (state) => {
            return {
                ...state,
                loading: true
            }
        },
        getProfileSuccess: (state, action) => {
            return {
                ...state,
                profile: action && action.payload && action.payload.data && action.payload.data.data,
                meta: action && action.payload && action.payload.data && action.payload.data.meta,
                loading: false,
                hasErrors: false
            }
        },
        getProfileFailure: (state, action) => {
            return {
                ...state,
                loading: false,
                hasErrors: true
            }
        },
        putProfile: (state) => {
            return {
                ...state,
                loading: true
            }
        },
        putProfileSuccess: (state, action) => {
            return {
                ...state,
                profile: action && action.payload && action.payload.data && action.payload.data.data,
                message: action && action.payload && action.payload.data && action.payload.data.data && action.payload.data.data.message,
                loading: false,
                hasErrors: false                
            }
        },
        putProfileFailure: (state, action) => {
            return {
                ...state,
                loading: false,
                hasErrors: true,
                message: action && action.payload && action.payload.data && action.payload.data.data && action.payload.data.data.message
            }
        },
        putProductSettings: (state) => {
            return {
                ...state,
                loading: true
            }
        },
        putProductSettingsSuccess: (state, action) => {
            return {
                ...state,
                profile: action && action.payload && action.payload.data && action.payload.data.data,
                message: action && action.payload && action.payload.data && action.payload.data.data && action.payload.data.data.message,
                loading: false,
                hasErrors: false,
                notification: { show: true, messageContent: (action.payload && action.payload.data && action.payload.data.data && action.payload.data.data.message === "Product settings Saved Successfully") ? ["Product settings Saved Successfully"] : [""], messageType: "success" }
            }
        },
        putProductSettingsFailure: (state, action) => {
            return {
                ...state,
                loading: false,
                hasErrors: true,
                message: action && action.payload && action.payload.data && action.payload.data.data && action.payload.data.data.message,
                notification: { show: true, messageContent: action.payload && action.payload.data && action.payload.data.data && action.payload.data.data.message ? [action.payload.data.data.message] : [""], messageType: "error" }

            }
        },
        resetProfileSettings: (state, action) => {
            return {
                ...state,
                    profile: action && action.payload && action.payload.data && action.payload.data.data,
                    notification: { show: false, messageContent: "", messageType: "success" }
            }
        }

    }
})
export const { getProfile, getProfileSuccess, getProfileFailure, putProfile,
    putProfileSuccess, putProfileFailure, putProductSettings,
    putProductSettingsSuccess, putProductSettingsFailure,resetProfileSettings } = profileslice.actions;


export const fetchProfile = data => dispatch => {
    dispatch(getProfile());
    try {
        OMSPROFILE.get('/profile')
            .then(function (response) {
                dispatch(getProfileSuccess(response));
            }).catch(function (error) {
                dispatch(getProfileFailure());
            })
    }
    catch (error) {
        dispatch(getProfileFailure());
    }
}
export const updateProfile = (userid,data) => dispatch => {
    dispatch(putProfile());
    const logRef = crypto.randomUUID();
    try {
        OMSPROFILE.patch('/profile/1', data, { 
            headers: { 
                'x-log-ref': logRef
                 } 
            })
            .then(function (response) {
                dispatch(putProfileSuccess(response));
                dispatch(getProfileSuccess(response));
                logFrontendActivity({
                    group: 'SETTINGS',
                    subgroup: 'PROFILE',
                    action: 'SUCCESS',
                    request_data: data,
                    response_data: response.data,
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }else{
                        console.log('Activity log failed:', ref);
                    }
                });
            }).catch(function (error) {
                dispatch(putProfileFailure(error.response));
                logFrontendActivity({
                    group: 'SETTINGS',
                    subgroup: 'PROFILE',
                    action: 'FAILURE',
                    request_data: data,
                    response_data: error.response?.data || {},
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }
                });
            })
    }
    catch (error) {
        dispatch(putProfileFailure());
    }
}
export const updateProductSettings = (userid,data) => dispatch => {
    dispatch(putProductSettings());
    const logRef = crypto.randomUUID();
    try {
        OMSPROFILE.post('/product-settings', data,{
            headers: {
                'x-log-ref': logRef // ✅ pass log_ref to backend
            }
        })
            .then(function (response) {
                dispatch(putProductSettingsSuccess(response));
                dispatch(fetchProfile());
                logFrontendActivity({
                    group: 'SETTINGS',
                    subgroup: 'PRODUCT_SETTINGS',
                    action: 'SUCCESS',
                    request_data: data,
                    response_data: response.data,
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }else{
                        console.log('Activity log failed:', ref);
                    }
                });
            }).catch(function (error) {
                dispatch(putProductSettingsFailure(error.response));
                logFrontendActivity({
                    group: 'SETTINGS',
                    subgroup: 'PRODUCT_SETTINGS',
                    action: 'FAILURE',
                    request_data: data,
                    response_data: error.response?.data || {},
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }
                });
            })
    }
    catch (error) {
         dispatch(putProductSettingsFailure(error.response));
         logFrontendActivity({
            group: 'SETTINGS',
            subgroup: 'PRODUCT_SETTINGS',
            action: 'FAILURE',
            request_data: data,
            response_data: error.response?.data || {},
            log_ref: logRef,
            userid: userid
        }).then((ref) => {
            if (ref) {
                console.log('Activity log recorded with log_ref:', ref);
            }
        });
    }
}
export const resetProfile = () => {
    return (dispatch) => {
        dispatch(resetProfileSettings());
        dispatch(fetchProfile());
    }
}
export default profileslice.reducer;
